import { memo } from 'react';
import { QRCodeSVG } from 'qrcode.react';

interface PaymentQRCodeProps {
  value: string;
  size?: number;
  color?: string;
  logoSrc?: string;
  logoAlt?: string;
}

function PaymentQRCode({
  value,
  size = 250,
  color = '#1e40af',
  logoSrc,
  logoAlt = 'QR logo',
}: PaymentQRCodeProps) {
  const logoSize = Math.round(size * 0.2);

  return (
    <QRCodeSVG
      value={value}
      size={size}
      level="M"
      includeMargin={false}
      fgColor={color}
      bgColor="#ffffff"
      imageSettings={
        logoSrc
          ? {
              src: logoSrc,
              width: logoSize,
              height: logoSize,
              excavate: true,
              opacity: 1,
            }
          : undefined
      }
      title={logoAlt}
    />
  );
}

export default memo(PaymentQRCode);
